// @flow
/* eslint-disable react/no-danger */
import React from 'react';

const icon = {
    __html: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <path fill="#999" fill-rule="evenodd" d="M8 5.14C3.586 5.14 0 4 0 2.57 0 1.164 3.586 0 8 0s8 1.164 8 2.57C16 4 12.414 5.14 8 5.14zm0 .72c3.29 0 6.61-.61 7.945-1.9l-2.18 2.61.485.485c.82.82.82 2.18-.016 3.015l-1.398 1.375c-.82.82-2.195.82-3.031 0l-.125-.086-.54.532v2.968C9.14 15.484 8.626 16 8 16c-.625 0-1.14-.516-1.14-1.14v-2.97L.124 3.96C1.485 5.25 4.711 5.86 8 5.86zm5.414 3.374a.943.943 0 0 0 0-1.343L13 7.484l-2.46 2.961.155.164a.943.943 0 0 0 1.344 0l1.375-1.375z"/>
    </svg>

`
};

export const IconGtFilter = () => <span dangerouslySetInnerHTML={icon} />;

export default IconGtFilter;
